var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17.5,
    r: 16.5,
    fill: "#FAA42A",
    stroke: "#FAA42A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0644 17.5273L25 21.7252L23.008 23.85C22.6608 24.2188 22.2484 24.5104 21.7948 24.7077C21.3411 24.9051 20.8552 25.0044 20.3652 24.9999C15.8121 24.9999 10.0001 18.8004 10.0001 13.9438C9.99614 13.4211 10.0894 12.9028 10.2744 12.4188C10.4594 11.9348 10.7326 11.4948 11.0781 11.1241L13.0701 9L17.0057 13.198L14.4144 15.962C15.1848 17.9148 16.6392 19.4697 18.4681 20.296L21.0644 17.5273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ccfee04e1f201501c36559c943a5e5d5.svg";
export { ForwardRef as ReactComponent };